import client from './client';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchTeacherProfile = async () => {
  const response = await client.get('/api/teacher-profile', {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createTeacherProfile = async (profileData) => {
  const response = await client.post('/api/teacher-profile', profileData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateTeacherProfile = async (profileId, updates) => {
  const response = await client.put(`/api/teacher-profile/${profileId}`, updates, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchAllTeacherProfiles = async () => {
  const response = await client.get('/api/teacher-profile/all', {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchTeacherProfileByYear = async (year) => {
  const response = await client.get(`/api/teacher-profile/year/${year}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteTeacherProfile = async (profileId) => {
  const response = await client.delete(`/api/teacher-profile/${profileId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
